import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Downtime',
  slug: 'downtime',
  definition: `Downtime is any period when a service, website, or system is unavailable to its users. It can range from a few seconds of intermittent errors to hours-long outages that affect an entire platform.

There are two main types. Planned downtime is scheduled in advance for maintenance, upgrades, or migrations. Unplanned downtime occurs unexpectedly due to hardware failures, software bugs, network issues, or security incidents.

Even partial downtime counts. If your API returns 500 errors for 20% of requests, that is degraded availability and effectively downtime for the affected users.`,
  whyItMatters: `Unplanned downtime costs businesses an average of $5,600 per minute according to industry studies. Beyond direct revenue loss, prolonged or frequent downtime erodes customer trust and damages brand reputation.

The real cost of downtime is often invisible. Users who encounter errors may not come back. Prospective customers who hit a broken page during their first visit are unlikely to try again. Minimizing downtime starts with detecting it quickly.`,
  howUptrackHelps: `Uptrack detects downtime in under a minute with 30-second check intervals. Confirmation checks eliminate false positives from transient network blips, so you only get alerted when there is a real problem.

When downtime occurs, Uptrack records the exact start and end times, giving you precise data for incident postmortems and SLA reporting.`,
  relatedTerms: [
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'Incident Management', href: '/glossary/incident-management' },
    { name: 'MTTD', href: '/glossary/mttd' },
    { name: 'Error Budget', href: '/glossary/error-budget' },
  ],
}

export const Route = createFileRoute('/_site/glossary/downtime')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
